import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  HostListener,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { AddCommentComponent } from "../add-comment/add-comment.component";
import { BaseService } from "../base.service";
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import { ToastrService } from "ngx-toastr";
import { ReportAbuseComponent } from "../report-abuse/report-abuse.component";
import { TranslateService } from "@ngx-translate/core";
import firebase from "firebase";
import { DocumentDetailComponent } from "../document-detail/document-detail.component";
import { ShareDetailContentComponent } from "../share-detail-content/share-detail-content.component";
import { VideoDetailComponent } from "../video-detail/video-detail.component";
@Component({
  selector: "app-video-info",
  templateUrl: "./video-info.component.html",
  styleUrls: ["./video-info.component.css"],
  providers: [DocumentDetailComponent, VideoDetailComponent],
})
export class VideoInfoComponent implements OnInit {
  @Input() videoDetail: any;
  @Output() docPlayStatus = new EventEmitter<boolean>();
  @Input() public_id: any;
  @Input() event: any;
  @Input() url: any;
  isReview = false;
  remindStatus = false;
  isFavorite: boolean;
  islike = 1;
  isDislike = 1;
  isLogin: boolean;
  moreDeatil: boolean;
  sendData: any = { offset: 0, limit: 10 };
  commentViewStatus = false;
  commentData = [];
  showComment = false;
  buttonStatus = true;
  commentCount = 0;
  appConstant: any = environment;
  scrollClass = true;
  commentShimmer: boolean;
  list: any = [];
  isLoading = false;
  likeLoader = false;
  dislikeLoader = false;
  sliceLength: any = 410;
  constructor(
    public dialog: MatDialog,
    public service: BaseService,
    private router: Router,
    private toastr: ToastrService,
    public translate: TranslateService,
    public document: DocumentDetailComponent,
    public VideoDetailComponent: VideoDetailComponent
  ) {}

  @Output() messageEvent = new EventEmitter<string>();
  ngOnInit(): void {
    if (localStorage.getItem(environment.localStorageKey)) {
      this.isLogin = true;
    }
    if (this.videoDetail) {
      this.videoDetail.likeDislikeDisable =
        this.videoDetail.is_user_likeDislike;
    }
    if (this.event === "like" || this.event === "dislike") {
      this.likeDislike(this.event);
    } else if (this.event === "is_favorite") {
      this.favoriteVideo();
    } else {
      if (this.event == "share") {
        this.openShareVideoContent();
      }
    }
  }
  @HostListener("scroll", ["$event"])
  @ViewChild("scroll")
  private myScrollContainer: ElementRef;
  descriptionLength() {
    if (this.sliceLength == 410) {
      this.sliceLength = this.videoDetail.description.length;
    } else {
      this.sliceLength = 410;
    }
  }
  menuToggle() {
    if (this.moreDeatil) {
      this.moreDeatil = false;
    } else {
      this.moreDeatil = true;
    }
  }
  singIn(event) {
    this.router.navigate(["/login"], {
      queryParams: { public_id: this.url, event: event },
    });
  }

  favoriteVideo() {
    this.isFavorite = !this.isFavorite;
    const id = {
      favorite_id: this.public_id,
      type: this.videoDetail.type,
      season_id: this.videoDetail.season_id,
    };
    if (localStorage.getItem(environment.localStorageKey)) {
      this.isLoading = true;
      if (!this.videoDetail.is_favorite.id) {
        this.service.addFavorite(id).subscribe(
          (detail) => {
            this.videoDetail.is_favorite.id = detail.id;
            this.videoDetail.is_favorite.is_favorite = "yes";
            this.isLoading = false;
            this.toastr.success("Added to watchlist", "Success!", {
              positionClass: "toast-bottom-left",
              closeButton: true,
            });
            // this.localData(detail);
            localStorage.removeItem(environment.pagesLocalStorageKey);
            if (environment.analyticsStatus) {
              const analytics = firebase.analytics();
              analytics.logEvent("like");
            }
          },
          (err) => {
            this.isLoading = false;
            this.toastr.error(err.error.message, "OOPS!", {
              closeButton: true,
            });
          }
        );
      } else {
        this.service.removeFavorite(this.videoDetail.is_favorite.id).subscribe(
          (detail) => {
            this.isLoading = false;
            this.videoDetail.is_favorite.id = "";
            this.videoDetail.is_favorite.is_favorite = "no";
            this.toastr.success("Removed from watchlist", "Success!", {
              positionClass: "toast-bottom-left",
              closeButton: true,
            });
            // this.localData(detail);
            localStorage.removeItem(environment.pagesLocalStorageKey);
            if (environment.analyticsStatus) {
              const analytics = firebase.analytics();
              analytics.logEvent("unlike");
            }
          },
          (err) => {
            this.isLoading = false;
            this.toastr.error(err.error.message, "OOPS!", {
              closeButton: true,
            });
          }
        );
      }
    }
  }
  localData(detail) {
    const localdata = JSON.parse(
      localStorage.getItem(environment.pagesLocalStorageKey)
    );
    if (localdata) {
      const index = localdata
        .map((el) => {
          return el.hasOwnProperty("home");
        })
        .indexOf(true);
      if (index !== -1) {
        localdata[index].home.subcategory.map((data) => {
          data.content.map((el) => {
            if (el.public_id === this.public_id) {
              if (detail === 1 || detail === 0) {
                el.is_user_likeDislike = detail;
              } else {
                el.is_favorite = detail;
              }
            }
          });
        });
        localStorage.setItem(
          environment.pagesLocalStorageKey,
          JSON.stringify(localdata)
        );
      }
    }
  }
  remindMe() {
    this.remindStatus = false;
    const id = {
      public_id: this.public_id,
      content_type: this.videoDetail.type,
    };
    if (localStorage.getItem(environment.localStorageKey)) {
      if (this.videoDetail.is_remindMe == "no") {
        this.service.addRemindMe(id).subscribe((detail) => {
          this.videoDetail.is_remindMe = "yes";
          this.remindStatus = true;
          this.toastr.success("Added to remind me", "Success!", {
            positionClass: "toast-bottom-left",
            closeButton: true,
          });
        });
      } else {
        this.remindStatus = false;
        this.service.removeRemindMe(id).subscribe((detail) => {
          this.remindStatus = true;
          this.videoDetail.is_remindMe = "no";
          this.toastr.success("Removed from remind me", "Success!", {
            positionClass: "toast-bottom-left",
            closeButton: true,
          });
        });
      }
    } else {
      if (this.videoDetail.is_remindMe == "no") {
        this.toastr.error("Please login to add remind me", "Whoops!", {
          closeButton: true,
          positionClass: "toast-bottom-left",
        });
      }
      this.router.navigate(["/login"], {
        queryParams: { public_id: this.url },
      });
    }
  }
  likeDislike(status) {
    if (status == 1 || status == "like") {
      this.likeLoader = true;
      status = 1;
    } else if (status == 0 || status == "dislike") {
      this.dislikeLoader = true;
      status = 0;
    }
    const sendData = {
      like_id: this.public_id,
      status: status,
      type: this.videoDetail.type,
      season_id: this.videoDetail.season_id,
    };
    if (localStorage.getItem(environment.localStorageKey)) {
      this.videoDetail.likeDislikeDisable = status;
      this.service.likeDislike(sendData).subscribe(
        () => {
          if (status === 1) {
            this.likeLoader = false;
            // this.toastr.success("Added to liked", "", {
            //   positionClass: "toast-bottom-left",
            // });
            this.videoDetail.total_like = this.videoDetail.total_like + 1;
            this.videoDetail.is_user_likeDislike = status;
            this.service.likeDislikeStatus = status;
            // this.localData(status);
            localStorage.removeItem(environment.pagesLocalStorageKey);
            if (this.videoDetail.is_user_likeDislike !== null) {
              if (this.videoDetail.total_dislike > 0) {
                this.videoDetail.total_dislike =
                  this.videoDetail.total_dislike - 1;
              }
            }
          } else {
            this.dislikeLoader = false;
            // this.toastr.success("You disliked this video", "", {
            //   positionClass: "toast-bottom-left",
            // });
            this.videoDetail.is_user_likeDislike = status;
            // this.localData(status);
            localStorage.removeItem(environment.pagesLocalStorageKey);
            this.service.likeDislikeStatus = status;
            if (this.videoDetail.is_user_likeDislike !== null) {
              if (this.videoDetail.total_like > 0) {
                this.videoDetail.total_like = this.videoDetail.total_like - 1;
              }
            }
            this.videoDetail.total_dislike = this.videoDetail.total_dislike + 1;
          }
        },
        (err) => {
          this.dislikeLoader = false;
          this.likeLoader = false;
          this.toastr.error(err.error.message, "OOPS!", {
            closeButton: true,
          });
        }
      );

      // } else {
      //   if (status === 1) {
      //     this.toastr.error("Please login to like", "Whoops!", {
      //       closeButton: true,
      //       positionClass: 'toast-bottom-left'
      //     });
      //   }
      //   else if (status === 0) {
      //     this.toastr.error("Please login to dislike", "Whoops!", {
      //       closeButton: true,
      //       positionClass: 'toast-bottom-left'
      //     });
      //   }

      //   this.router.navigate(['/login'], { queryParams: { public_id: this.url } });
    }
  }
  openDialog(publicId) {
    const dialogRef = this.dialog.open(AddCommentComponent, {
      width: "500px",
      data: {
        public_id: publicId,
        total_comment: this.videoDetail.total_comment,
        avg_rating: this.videoDetail.avg_rating,
        type: this.videoDetail.type,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (!this.showComment) {
          this.videoDetail.lastComment = result;
        } else {
          this.commentData.unshift(result);
        }
        this.videoDetail.avg_rating = result.avg_rating;
        this.videoDetail.total_comment = this.videoDetail.total_comment + 1;
        this.videoDetail.is_user_rating_review_status = 1;
      }
    });
  }

  openShareVideoContent() {
    const dialogRef = this.dialog.open(ShareDetailContentComponent, {
      panelClass: "song-dialog",
      data: this.videoDetail,
    });
  }

  getComment() {
    this.sendData.public_id = this.public_id;
    this.sendData.type = this.videoDetail.type;
    this.service.getComment(this.sendData).subscribe((res) => {
      if (res) {
        this.isReview = true;
        this.buttonStatus = true;
        this.commentData = this.commentData.concat(res.results);

        this.commentCount = res.counts;
      }
      this.commentShimmer = false;
    });
  }

  commentToggle() {
    this.sendData.offset = 0;
    if (this.showComment) {
      this.isReview = false;
      this.showComment = false;
      this.buttonStatus = true;
      this.commentData = [];
    } else {
      this.commentShimmer = true;
      this.showComment = true;
      this.isReview = false;
      this.buttonStatus = false;
      this.getComment();
    }
  }
  onScroll(event) {
    if (event.target.scrollTop === 0) {
      this.scrollClass = true;
    } else {
      this.scrollClass = false;
    }
    if (
      event.target.offsetHeight + event.target.scrollTop >=
      event.target.scrollHeight
    ) {
      this.sendData.offset += 10;
      if (this.sendData.offset < this.commentCount) {
        this.getComment();
      }
    }
  }

  openReport(publicId) {
    this.dialog.open(ReportAbuseComponent, {
      width: "500px",
      data: {
        public_id: publicId,
        type: this.videoDetail.type,
      },
    });
  }

  ngOnDestroy() {
    this.dialog.closeAll();
  }
}
